'use client';
import { OpenAPIEmptyExample } from './OpenAPIExample';
import { OpenAPISelect, OpenAPISelectItem, useSelectState } from './OpenAPISelect';
import { StaticSection } from './StaticSection';
/**
 * Get the state of the response examples select.
 */
export function useMediaTypesState(stateKey, initialKey) {
    if (initialKey === void 0) { initialKey = 'default'; }
    return useSelectState(stateKey, initialKey);
}
function useMediaTypeExamplesState(stateKey, initialKey) {
    if (initialKey === void 0) { initialKey = 'default'; }
    return useSelectState(stateKey, initialKey);
}
export function OpenAPIMediaTypeContent(props) {
    var _a, _b, _c;
    var stateKey = props.stateKey, items = props.items, selectIcon = props.selectIcon, context = props.context;
    var state = useMediaTypesState(stateKey, (_a = items[0]) === null || _a === void 0 ? void 0 : _a.key);
    var examples = (_c = (_b = items.find(function (item) { return item.key === state.key; })) === null || _b === void 0 ? void 0 : _b.examples) !== null && _c !== void 0 ? _c : [];
    if (!items.length && !examples.length) {
        return null;
    }
    return (<StaticSection footer={items.length > 1 || examples.length > 1 ? (<OpenAPIMediaTypeFooter items={items} examples={examples} selectIcon={selectIcon} stateKey={stateKey}/>) : null} className="openapi-response-media-types-examples">
            <OpenAPIMediaTypeBody context={context} stateKey={stateKey} items={items} examples={examples}/>
        </StaticSection>);
}
function OpenAPIMediaTypeFooter(props) {
    var items = props.items, examples = props.examples, stateKey = props.stateKey, selectIcon = props.selectIcon;
    return (<>
            {items.length > 1 && (<OpenAPISelect icon={selectIcon} items={items} stateKey={stateKey} placement="bottom start">
                    {items.map(function (item) { return (<OpenAPISelectItem key={item.key} id={item.key} value={item}>
                            <span>{item.label}</span>
                        </OpenAPISelectItem>); })}
                </OpenAPISelect>)}

            {examples && examples.length > 1 ? (<OpenAPISelect icon={selectIcon} items={examples} stateKey={"".concat(stateKey, "-examples")} placement="bottom start">
                    {examples.map(function (example) { return (<OpenAPISelectItem key={example.key} id={example.key} value={example}>
                            <span>{example.label}</span>
                        </OpenAPISelectItem>); })}
                </OpenAPISelect>) : null}
        </>);
}
function OpenAPIMediaTypeBody(props) {
    var _a, _b, _c, _d, _e;
    var stateKey = props.stateKey, items = props.items, examples = props.examples, context = props.context;
    var state = useMediaTypesState(stateKey, (_a = items[0]) === null || _a === void 0 ? void 0 : _a.key);
    var selectedItem = (_b = items.find(function (item) { return item.key === state.key; })) !== null && _b !== void 0 ? _b : items[0];
    var exampleState = useMediaTypeExamplesState("".concat(stateKey, "-examples"), (_d = (_c = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.examples) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.key);
    if (!selectedItem) {
        return null;
    }
    if (examples) {
        var selectedExample = (_e = examples.find(function (example) { return example.key === exampleState.key; })) !== null && _e !== void 0 ? _e : examples[0];
        if (!selectedExample) {
            return <OpenAPIEmptyExample context={context}/>;
        }
        return selectedExample.body;
    }
    return selectedItem.body;
}
